<template>
  <div>
    <div class="container">
      <h1>Terms of Service for Nubox App</h1>
      <div style="height: 50px"></div>
      <h2>1. Introduction</h2>
      <p>
        Welcome to Nubox App. These Terms of Service ("Terms") govern your use
        of the Nubox mobile application ("App"), website, and services provided
        by Nubox ("we", "us", "our"). By accessing or using our App, you agree
        to be bound by these Terms and our Privacy Policy.
      </p>

      <h2>2. App Description</h2>
      <p>
        Nubox App provides advanced analytics, inventory management, and
        customer behavior insights for vending machine operators. The App
        collects and analyzes sales data to help optimize product offerings and
        increase efficiency.
      </p>

      <h2>3. User Eligibility</h2>
      <p>
        The App is intended for use by individuals aged 18 and older. By using
        the App, you represent and warrant that you are of legal age to form a
        binding contract.
      </p>

      <h2>4. Account Registration</h2>
      <p>
        To access certain features of the App, you must register for an account.
        You agree to (a) provide accurate, truthful, current, and complete
        information; (b) maintain and promptly update your account information;
        (c) maintain the security of your password; (d) accept all risks of
        unauthorized access to your account; and (e) notify us immediately if
        you discover or otherwise suspect any security breaches related to the
        App.
      </p>

      <h2>5. Privacy Policy</h2>
      <p>
        Our Privacy Policy describes how we handle the information you provide
        to us when you use our App. You understand that through your use of the
        App, you consent to the collection and use of this information.
      </p>

      <h2>6. User Conduct</h2>
      <p>
        You agree not to engage in any of the following prohibited activities:
        (i) copying, distributing, or disclosing any part of the App in any
        medium; (ii) using any automated system, including robots, spiders,
        offline readers, etc., to access the App; (iii) transmitting spam, chain
        letters, or other unsolicited email; (iv) attempting to interfere with
        the servers or network; (v) circumventing measures we may use to prevent
        or restrict access to the App.
      </p>

      <h2>7. Intellectual Property Rights</h2>
      <p>
        The App and all intellectual property rights therein, are the exclusive
        property of Nubox and its licensors. Except as expressly permitted in
        these Terms, you may not copy, modify, distribute, sell, or lease any
        part of our App, nor may you reverse engineer or attempt to extract the
        source code of that software.
      </p>

      <h2>8. Third-Party Links and Content</h2>
      <p>
        The App may contain links to third-party websites or resources. You
        acknowledge and agree that we are not responsible or liable for: (i) the
        availability or accuracy of such websites or resources; or (ii) the
        content, products, or services on or available from such websites or
        resources.
      </p>

      <h2>9. Modifications to the App</h2>
      <p>
        We reserve the right at any time to modify or discontinue, temporarily
        or permanently, the App (or any part thereof) with or without notice.
        You agree that Nubox shall not be liable to you or to any third party
        for any modification, suspension, or discontinuance of the App.
      </p>

      <h2>10. Termination</h2>
      <p>
        We may terminate your access to and use of the App, at our sole
        discretion, at any time, and without notice to you. Upon any
        termination, discontinuation, or cancellation of services or your
        account, the following provisions of these Terms will survive: User
        Conduct, Intellectual Property Rights, Limitation of Liability, and
        Governing Law.
      </p>

      <h2>11. Warranty Disclaimer</h2>
      <p>
        The App is provided on an "as is" and "as available" basis. Nubox and
        its affiliates expressly disclaim any warranties of any kind, whether
        express or implied, including, but not limited to, the implied
        warranties of merchantability, fitness for a particular purpose, title,
        and non-infringement.
      </p>

      <h2>12. Limitation of Liability</h2>
      <p>
        In no event will Nubox, its affiliates, agents, directors, employees,
        suppliers, or licensors be liable for any indirect, punitive,
        incidental, special, consequential, or exemplary damages, including
        damages for loss of profits, goodwill, use, data, or other intangible
        losses, that result from the use of, or inability to use, this service.
      </p>

      <h2>13. Governing Law</h2>
      <p>
        These Terms shall be governed by and construed in accordance with the
        laws of the jurisdiction in which Nubox is based, without regard to its
        conflict of law principles.
      </p>

      <h2>14. Changes to Terms</h2>
      <p>
        We reserve the right, at our sole discretion, to modify or replace these
        Terms at any time. If a revision is material, we will provide at least
        30 days' notice prior to any new terms taking effect. What constitutes a
        material change will be determined at our sole discretion.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.container {
  width: 80%;
  margin: auto;
  overflow: hidden;
  padding-top: 20px;
}

h1,
h2 {
  color: #333;
}

p,
li {
  font-size: 1.1em;
}

ul {
  margin: 10px 0;
}
</style>